import React from 'react';
import Header from '../components/header'
import Footer from '../components/footer';
import { VerticalSeparator, LineSeparator } from '../components/separators';
import AreYouInterestedComponent from '../components/areYouInterestedComponent.js';
import ServicesComponent from '../components/services';
import FotoProfilo from '../photos/Case/Facciata/esterno primo piano 3.jpg'
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect } from 'react';
import GalleryComponent from '../components/galleryWrapper.js';
import DataHousePage2 from '../galleries/data/dataHousePage2.ts';
import PetIcon from '../icons/pet_friendly.png';
import NoSmokingIcon from '../icons/no_smoking.png';
import './housePage.css';

const House2Page = (props) => {

  const { selectedLanguage, handleLanguageChange } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header selectedLanguage={selectedLanguage} handleLanguageChange={handleLanguageChange} />

      <Container fluid style={{ width: '100%' }}>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <h1 className='text-h-housepage-class' style={{ textAlign: 'center' }}>{selectedLanguage === 'ita' ? "Primo Piano" : "First Floor"}</h1>
        <VerticalSeparator height={"2vw"}></VerticalSeparator>
        <Row>
          <Col md={6} style={{ alignContent: 'center' }}>
            <img src={FotoProfilo} alt="" className="img-fluid" style={{ width: '100%', height: '100%', maxHeight: '1000px', borderRadius: '12px', objectFit: 'cover' }} />
          </Col>
          <Col md={6}>
            <div style={{ textAlign: 'justify', marginLeft: '10px', marginRight: '10px' }}>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
              <p className='text-p-housepage-class'>
                {selectedLanguage === 'ita' ? "L’appartamento al primo piano offre una spaziosa terrazza con vista mare potrai così godere al meglio il tuo soggiorno respirando la frizzante aria di mare e allo stesso tempo la tranquillità di una zona appartata." : "The apartment on the first floor offers a spacious terrace with a sea view, allowing you to fully enjoy your stay while breathing in the fresh sea air and at the same time the tranquility of a secluded area."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "Dalla terrazza si accede da un ampio e luminoso soggiorno con divano letto e angolo cottura completamente attrezzato. Dal corridoio si accede alle due camere da letto una matrimoniale e l’altra doppia ma eventualmente trasformabile in matrimoniale, il bagno è con doccia." : "The terrace leads to a spacious and bright living room with a sofa bed and a fully equipped kitchenette. From the corridor, you can access the two bedrooms, one double and the other twin but optionally convertible into a double, and the bathroom with a shower."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "Questa casa vacanza è perfetta per qualsiasi famiglia anche con bambini infatti possiamo fornirvi gratuitamente di passeggino, seggiolone e culla da campeggio. Ogni ambiente è climatizzato ed è dotato di WiFi." : "This holiday home is perfect for any family, even with children, as we can provide you with a stroller, high chair, and travel cot free of charge. Each room is air-conditioned and equipped with WiFi."}
                <br />
                <br />
                {selectedLanguage === 'ita' ? "A pochi passi troverete supermercati, ristoranti, pizzerie e bar con accanto area giochi all’aperto per bambini." : "A few steps away, you will find supermarkets, restaurants, pizzerias, and bars with outdoor play areas for children."}
                <br />
              </p>
              <div>
                <img src={NoSmokingIcon} alt='' className='text-i-housepage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
                <span className='text-p-housepage-class'>{selectedLanguage === 'ita' ? "Divieto di fumo nei locali interni" : "Smoking ban in internal spaces"}</span>
              </div>
              <div>
                <img src={PetIcon} alt='' className='text-i-housepage-class' style={{ width: '4vw', height: '4vw', marginRight: '10px' }} />
                <span className='text-p-housepage-class'>{selectedLanguage === 'ita' ? "Animali consentiti" : "Pet allowed"}</span>
              </div>
              <VerticalSeparator height={"2vw"}></VerticalSeparator>
            </div>
          </Col>
        </Row>
      </Container>


      <LineSeparator></LineSeparator>

      <ServicesComponent selectedLanguage={selectedLanguage} ></ServicesComponent>

      <LineSeparator></LineSeparator>

      <AreYouInterestedComponent selectedLanguage={selectedLanguage} ></AreYouInterestedComponent>

      <LineSeparator></LineSeparator>

      <GalleryComponent text={selectedLanguage === 'ita' ? "Galleria" : "Gallery"} DataHousePage1={DataHousePage2}></GalleryComponent>

      <Footer />
    </>
  );
}

export default House2Page;
